<div class="content">
    @for (item of projects; track $index) {
    <div class="project-div" [ngClass]="{
    'reverse': $index % 2 !== 0,
    'offset-left': $index % 2 === 1,
    'offset-right': $index % 2 === 0
  }">
        <img src=" {{item.image}}" alt="">
        <div class="projectright">
            <h3>{{item.name}}</h3>
            <span class="skillspan">{{item.skills}}</span>
            <span class="description">{{item.description[currentLang]}}</span>
            <div class="links">
                <a href="{{item.urlLiveTest}}" target="_blank" class="livetest">Live test</a>
                <a href="{{item.urlGithub}}" target="_blank" class="github">Github</a>
            </div>
        </div>
    </div>
    }
</div>